/**
 * MockStorage is a simple in-memory implementation of the session/local Storage API.
 * It provides getItem, setItem, and removeItem methods to mimic the behavior of sessionStorage.
 * This is useful for environments where sessionStorage is not available (e.g., testing environments).
 */
export default class MockStorage {
  constructor() {
    this.store = {};
  }

  getItem(key) {
    return this.store[key] || null;
  }

  setItem(key, value) {
    this.store[key] = value.toString();
  }

  removeItem(key) {
    delete this.store[key];
  }
}
